import React from 'react';
import { useTranslation } from 'localization';
import ButtonAtom from '../Button/ButtonAtom';
import ChipAtom from '../Chip/ChipAtom';
import './SelectionBarAtom.scss';

export interface SelectionBarSelection {
  key: string;
  name: string;
  timeframeName: string;
}

export interface SelectionBarAtomProps {
  selections: SelectionBarSelection[];
  onRemove: (key: string) => void;
  onCancel: () => void;
  onApply: () => void;
  applying?: boolean;
  className?: string;
}

const SelectionBarAtom: React.FC<SelectionBarAtomProps> = ({
  selections,
  onRemove,
  onCancel,
  onApply,
  applying = false,
  className = '',
}) => {
  const { t } = useTranslation();
  const count = selections.length;

  return (
    <div
      className={className ? `selection-bar ${className}` : 'selection-bar'}
      role="toolbar"
      aria-label={t('periodSelector.selectionBar.label')}
    >
      <div className="selection-bar__chips">
        {selections.map((s) => (
          <ChipAtom
            key={s.key}
            label={`${s.name} · ${s.timeframeName}`}
            removable
            onRemove={() => { onRemove(s.key); }}
            className="selection-bar__chip"
          />
        ))}
      </div>

      <div className="selection-bar__actions">
        <ButtonAtom
          label={t('periodSelector.cancel')}
          variant="secondary"
          size="small"
          shape="pill"
          onClick={onCancel}
        />
        <ButtonAtom
          label={count > 0 ? `${t('periodSelector.ApplySelection')} (${count})` : t('periodSelector.ApplySelection')}
          variant="primary"
          size="small"
          shape="pill"
          onClick={onApply}
          disabled={count === 0 || applying}
          loading={applying}
        />
      </div>
    </div>
  );
};

export default SelectionBarAtom;
